/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Agent_Run_Action_PerformedInputs */



/**
* | output |
* | --- |
* | "{action}: done" |
*
* @param {Agent_Run_Action_PerformedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_action_performed = /** @type {((inputs: Agent_Run_Action_PerformedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Action_PerformedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.action}: erledigt`)
	return /** @type {LocalizedString} */ (`${i?.action}: done`)
});